<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { getTrainings } from '../scripts/apiTrainings';
    import { storeTrainings, storeTrainingsError } from "../scripts/training";
    import { addNotificationError }  from "../scripts/toaster";
    import TileTraining from '../components/TileTraining.svelte';
    import { storeLanguage, lang_fr } from "../scripts/store";

    onMount(async () => {
        getTrainingsIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getTrainingsIfEmpty
     */
     function getTrainingsIfEmpty() {
        if ($storeTrainings.length <= 0) {
            const returnValue = getTrainings();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeTrainingsError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .nosPartenairesFormations {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 60px 32px;
            width: 100%;
        }
    }

    @include large {
        .nosPartenairesFormations {
            &__tiles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__tile {
                cursor: default;
                width: 30%;
                
            }
        }
    }

</style>

<div class="nosPartenairesFormations">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="formations de nos partenaires"/>
    {:else}
    <PageHeader props="partners training"/>
    {/if}
    <div class="bloc nosPartenairesFormations__bloc">
        <div class="nosPartenairesFormations__title font__h3">
            {#if ($storeLanguage == $lang_fr)}
            Retrouvez ci-dessous l’ensemble des formations proposées par nos partenaires
            {:else}
            Find below all the training courses offered by our partners
            {/if}
        </div>
        <div class="nosPartenairesFormations__tiles">
            {#if ($storeTrainingsError != "")}
            <div class="getallarticles__article getallarticles__error">
                <p>Error : {$storeTrainingsError}</p>
            </div>
            {:else}
            {#key $storeTrainings}
            {#each $storeTrainings as training, i}
            <div class="nosPartenairesFormations__tile">
                {#if ($storeLanguage == $lang_fr)}
                <TileTraining props={{indice: i, id_partner: training.id_partner, title: training.title_fr, text: training.description_fr, url_training: training.url_training}}/>
                {:else}
                <TileTraining props={{indice: i, id_partner: training.id_partner, title: training.title_en, text: training.description_en, url_training: training.url_training}}/>
                {/if}
            </div>
            {/each}
            {/key}
            {/if}
        </div>    
    </div>
</div>
